// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file strategy.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file strategy.proto.
 */
export const file_strategy: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message cryptotrader.StrategyInfoResponse
 */
export type StrategyInfoResponse = Message<"cryptotrader.StrategyInfoResponse"> & {
  /**
   * @generated from field: cryptotrader.StrategyInfoStatus status = 1;
   */
  status: StrategyInfoStatus;

  /**
   * UNSUPPORTED: why
   *
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * INVALID: every problem
   *
   * @generated from field: repeated cryptotrader.DeclarationProblem problems = 3;
   */
  problems: DeclarationProblem[];

  /**
   * OK
   *
   * @generated from field: cryptotrader.StrategyInfo info = 4;
   */
  info?: StrategyInfo | undefined;

  /**
   * OK, strategies only: by engine provider.
   *
   * @generated from field: map<string, cryptotrader.EngineSuggestion> engines = 5;
   */
  engines: { [key: string]: EngineSuggestion };
};

/**
 * Describes the message cryptotrader.StrategyInfoResponse.
 * Use `create(StrategyInfoResponseSchema)` to create a new message.
 */
export const StrategyInfoResponseSchema: GenMessage<StrategyInfoResponse> = /*@__PURE__*/
  messageDesc(file_strategy, 0);

/**
 * @generated from message cryptotrader.DeclarationProblem
 */
export type DeclarationProblem = Message<"cryptotrader.DeclarationProblem"> & {
  /**
   * 0 when unknown
   *
   * @generated from field: int32 line = 1;
   */
  line: number;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message cryptotrader.DeclarationProblem.
 * Use `create(DeclarationProblemSchema)` to create a new message.
 */
export const DeclarationProblemSchema: GenMessage<DeclarationProblem> = /*@__PURE__*/
  messageDesc(file_strategy, 1);

/**
 * @generated from message cryptotrader.StrategyInfo
 */
export type StrategyInfo = Message<"cryptotrader.StrategyInfo"> & {
  /**
   * @generated from field: cryptotrader.ScriptKind kind = 1;
   */
  kind: ScriptKind;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * language version (Pine //@version)
   *
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * of the declaration; 0 without one
   *
   * @generated from field: int32 line = 4;
   */
  line: number;

  /**
   * Backtest properties the script writes; the rest are the language's
   * defaults for the version.
   *
   * @generated from field: repeated string declared = 5;
   */
  declared: string[];

  /**
   * @generated from field: cryptotrader.BacktestProperties backtest = 6;
   */
  backtest?: BacktestProperties | undefined;
};

/**
 * Describes the message cryptotrader.StrategyInfo.
 * Use `create(StrategyInfoSchema)` to create a new message.
 */
export const StrategyInfoSchema: GenMessage<StrategyInfo> = /*@__PURE__*/
  messageDesc(file_strategy, 2);

/**
 * @generated from message cryptotrader.BacktestProperties
 */
export type BacktestProperties = Message<"cryptotrader.BacktestProperties"> & {
  /**
   * @generated from field: double initial_capital = 1;
   */
  initialCapital: number;

  /**
   * empty = the symbol's quote currency
   *
   * @generated from field: string currency = 2;
   */
  currency: string;

  /**
   * @generated from field: cryptotrader.OrderSize order_size = 3;
   */
  orderSize?: OrderSize | undefined;

  /**
   * @generated from field: cryptotrader.Commission commission = 4;
   */
  commission?: Commission | undefined;

  /**
   * @generated from field: int32 pyramiding = 5;
   */
  pyramiding: number;

  /**
   * percent of the position value
   *
   * @generated from field: double margin_long = 6;
   */
  marginLong: number;

  /**
   * @generated from field: double margin_short = 7;
   */
  marginShort: number;

  /**
   * ticks
   *
   * @generated from field: int32 slippage = 8;
   */
  slippage: number;

  /**
   * ticks
   *
   * @generated from field: int32 fill_limits_assumption = 9;
   */
  fillLimitsAssumption: number;

  /**
   * FIFO | ANY
   *
   * @generated from field: string close_entries_rule = 10;
   */
  closeEntriesRule: string;

  /**
   * @generated from field: bool process_orders_on_close = 11;
   */
  processOrdersOnClose: boolean;

  /**
   * @generated from field: bool calc_on_order_fills = 12;
   */
  calcOnOrderFills: boolean;

  /**
   * @generated from field: bool calc_on_every_tick = 13;
   */
  calcOnEveryTick: boolean;

  /**
   * @generated from field: bool calc_on_every_history_tick = 14;
   */
  calcOnEveryHistoryTick: boolean;

  /**
   * @generated from field: bool use_bar_magnifier = 15;
   */
  useBarMagnifier: boolean;

  /**
   * @generated from field: bool fill_orders_on_standard_ohlc = 16;
   */
  fillOrdersOnStandardOhlc: boolean;

  /**
   * annual percent
   *
   * @generated from field: double risk_free_rate = 17;
   */
  riskFreeRate: number;

  /**
   * 0 = all bars
   *
   * @generated from field: int32 calc_bars_count = 18;
   */
  calcBarsCount: number;
};

/**
 * Describes the message cryptotrader.BacktestProperties.
 * Use `create(BacktestPropertiesSchema)` to create a new message.
 */
export const BacktestPropertiesSchema: GenMessage<BacktestProperties> = /*@__PURE__*/
  messageDesc(file_strategy, 3);

/**
 * @generated from message cryptotrader.OrderSize
 */
export type OrderSize = Message<"cryptotrader.OrderSize"> & {
  /**
   * @generated from field: cryptotrader.OrderSizeUnit unit = 1;
   */
  unit: OrderSizeUnit;

  /**
   * @generated from field: double value = 2;
   */
  value: number;
};

/**
 * Describes the message cryptotrader.OrderSize.
 * Use `create(OrderSizeSchema)` to create a new message.
 */
export const OrderSizeSchema: GenMessage<OrderSize> = /*@__PURE__*/
  messageDesc(file_strategy, 4);

/**
 * @generated from message cryptotrader.Commission
 */
export type Commission = Message<"cryptotrader.Commission"> & {
  /**
   * @generated from field: cryptotrader.CommissionUnit unit = 1;
   */
  unit: CommissionUnit;

  /**
   * @generated from field: double value = 2;
   */
  value: number;
};

/**
 * Describes the message cryptotrader.Commission.
 * Use `create(CommissionSchema)` to create a new message.
 */
export const CommissionSchema: GenMessage<Commission> = /*@__PURE__*/
  messageDesc(file_strategy, 5);

/**
 * @generated from message cryptotrader.EngineSuggestion
 */
export type EngineSuggestion = Message<"cryptotrader.EngineSuggestion"> & {
  /**
   * Engine parameters the strategy sets; the rest keep the engine's defaults.
   *
   * @generated from field: map<string, string> config = 1;
   */
  config: { [key: string]: string };

  /**
   * @generated from field: repeated cryptotrader.UnsupportedProperty unsupported = 2;
   */
  unsupported: UnsupportedProperty[];
};

/**
 * Describes the message cryptotrader.EngineSuggestion.
 * Use `create(EngineSuggestionSchema)` to create a new message.
 */
export const EngineSuggestionSchema: GenMessage<EngineSuggestion> = /*@__PURE__*/
  messageDesc(file_strategy, 6);

/**
 * @generated from message cryptotrader.UnsupportedProperty
 */
export type UnsupportedProperty = Message<"cryptotrader.UnsupportedProperty"> & {
  /**
   * @generated from field: string property = 1;
   */
  property: string;

  /**
   * e.g. "a commission of 1.5 per order"
   *
   * @generated from field: string setting = 2;
   */
  setting: string;

  /**
   * the engine parameter that replaces it; empty if none
   *
   * @generated from field: string param = 3;
   */
  param: string;
};

/**
 * Describes the message cryptotrader.UnsupportedProperty.
 * Use `create(UnsupportedPropertySchema)` to create a new message.
 */
export const UnsupportedPropertySchema: GenMessage<UnsupportedProperty> = /*@__PURE__*/
  messageDesc(file_strategy, 7);

/**
 * @generated from enum cryptotrader.StrategyInfoStatus
 */
export enum StrategyInfoStatus {
  /**
   * @generated from enum value: STRATEGY_INFO_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STRATEGY_INFO_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * the declaration has problems
   *
   * @generated from enum value: STRATEGY_INFO_STATUS_INVALID = 2;
   */
  INVALID = 2,

  /**
   * the strategy can't describe itself
   *
   * @generated from enum value: STRATEGY_INFO_STATUS_UNSUPPORTED = 3;
   */
  UNSUPPORTED = 3,
}

/**
 * Describes the enum cryptotrader.StrategyInfoStatus.
 */
export const StrategyInfoStatusSchema: GenEnum<StrategyInfoStatus> = /*@__PURE__*/
  enumDesc(file_strategy, 0);

/**
 * @generated from enum cryptotrader.ScriptKind
 */
export enum ScriptKind {
  /**
   * @generated from enum value: SCRIPT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * no declaration statement
   *
   * @generated from enum value: SCRIPT_KIND_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: SCRIPT_KIND_INDICATOR = 2;
   */
  INDICATOR = 2,

  /**
   * @generated from enum value: SCRIPT_KIND_STRATEGY = 3;
   */
  STRATEGY = 3,

  /**
   * @generated from enum value: SCRIPT_KIND_LIBRARY = 4;
   */
  LIBRARY = 4,
}

/**
 * Describes the enum cryptotrader.ScriptKind.
 */
export const ScriptKindSchema: GenEnum<ScriptKind> = /*@__PURE__*/
  enumDesc(file_strategy, 1);

/**
 * @generated from enum cryptotrader.OrderSizeUnit
 */
export enum OrderSizeUnit {
  /**
   * @generated from enum value: ORDER_SIZE_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_SIZE_UNIT_CONTRACTS = 1;
   */
  CONTRACTS = 1,

  /**
   * @generated from enum value: ORDER_SIZE_UNIT_CASH = 2;
   */
  CASH = 2,

  /**
   * @generated from enum value: ORDER_SIZE_UNIT_PERCENT_OF_EQUITY = 3;
   */
  PERCENT_OF_EQUITY = 3,
}

/**
 * Describes the enum cryptotrader.OrderSizeUnit.
 */
export const OrderSizeUnitSchema: GenEnum<OrderSizeUnit> = /*@__PURE__*/
  enumDesc(file_strategy, 2);

/**
 * @generated from enum cryptotrader.CommissionUnit
 */
export enum CommissionUnit {
  /**
   * @generated from enum value: COMMISSION_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMMISSION_UNIT_PERCENT = 1;
   */
  PERCENT = 1,

  /**
   * @generated from enum value: COMMISSION_UNIT_PER_CONTRACT = 2;
   */
  PER_CONTRACT = 2,

  /**
   * @generated from enum value: COMMISSION_UNIT_PER_ORDER = 3;
   */
  PER_ORDER = 3,
}

/**
 * Describes the enum cryptotrader.CommissionUnit.
 */
export const CommissionUnitSchema: GenEnum<CommissionUnit> = /*@__PURE__*/
  enumDesc(file_strategy, 3);

